import { metaData } from '@cornerstonejs/core';
import { fetchPaletteData } from './fetchPaletteData';
export async function fetchLUTForInstance(imageFrame) {
    const fetchPromises = [];
    const needsPaletteLUT = !imageFrame.redPaletteColorLookupTableData ||
        !imageFrame.greenPaletteColorLookupTableData ||
        !imageFrame.bluePaletteColorLookupTableData;
    if (needsPaletteLUT) {
        const palettePromises = Promise.all([
            fetchPaletteData(imageFrame, 'red', null),
            fetchPaletteData(imageFrame, 'green', null),
            fetchPaletteData(imageFrame, 'blue', null),
        ]).then(([redData, greenData, blueData]) => {
            imageFrame.redPaletteColorLookupTableData = redData;
            imageFrame.greenPaletteColorLookupTableData = greenData;
            imageFrame.bluePaletteColorLookupTableData = blueData;
        });
        fetchPromises.push(palettePromises);
    }
    if (fetchPromises.length > 0) {
        await Promise.all(fetchPromises);
    }
}
